module.exports = __webpack_public_path__ + "img/wxi.d83a3359.jpg";